<template>
  <footer>
    <v-list
        v-if="showFooter"
        dense
    >
      <v-list-item color="primary" @click="openCRM">
        <v-list-item-title class="text-right primary--text">
          Открыть органайзер
        </v-list-item-title>

        <v-list-item-icon>
          <v-icon color="primary">mdi-developer-board</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <v-footer
        v-if="showAcquiringMenu"
        color="gray darken-1"
    >
      <v-row
          justify="center"
          no-gutters
      >
        <v-btn
            class="mx-2"
            small
            text
            :to="{name: acquiringAboutState}"
        >
          О нас
        </v-btn>
        <v-btn
          v-if="hasAcquiringProducts"
          :to="{name: acquiringDemoProducts}"
          class="mx-2"
          small
          text
        >
          Товары
        </v-btn>
        <v-btn
            class="mx-2"
            small
            text
            :to="{name: acquiringPaymentInfoState}"
        >
          Оплата, доставка и возврат
        </v-btn>
        <v-btn
            class="mx-2"
            small
            text
            :to="{name: acquiringDocumentsState}"
        >
          Документы
        </v-btn>
      </v-row>
    </v-footer>
  </footer>
</template>

<script>
import {getAcquiring} from '@/composables/acquiring'
import {getUser} from '@/composables/user'
import {appStates} from '@/constants'
import {windowOpen} from '@/services/vkApi'

export default {
  name: 'Footer',
  computed: {
    acquiring: getAcquiring,
    hasAcquiringProducts () {
      return this.showAcquiringMenu && this.acquiring.data.orders && this.acquiring.data.orders.length
    },
    showAcquiringMenu () {
      return this.acquiring.resolved && this.acquiring.data && this.acquiring.data.domain && !this.user.data.context
    },
    showFooter () {
      return !this.$API.OPENED_FROM_FS && !this.user.loading
          && (this.user.data.spOrg || this.user.context && this.user.context.viewer_type > 1)
    },
    user: getUser
  },
  data () {
    return {
      acquiringAboutState: appStates.acquiringAbout.name,
      acquiringDemoProducts: appStates.acquiringDemoProducts.name,
      acquiringDocumentsState: appStates.acquiringDocuments.name,
      acquiringPaymentInfoState: appStates.acquiringPaymentInfo.name,
      crmUrl: ''
    }
  },
  methods: {
    openCRM: function () {
      windowOpen(this.$API.APP_CRM_URL)
    }
  }
}
</script>

<style scoped>
</style>
